import React from 'react';
import { Spin } from 'antd';
import './styles.less';

const Loader = () => {
  return (
    <div className="loader-div">
      <Spin size="large" />
    </div>
  );
};

export default Loader;
